import isNil from 'lodash.isnil';
import omitBy from 'lodash.omitby';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import { CfFtpInfo } from 'data/cfFtpInfo/cfFtpInfo.types';

// eslint-disable-next-line import/prefer-default-export
export function createCfFtpInfoBasedOnTemplate(
  template: FormTemplate,
): CfFtpInfo {
  const cfFtpInfo: Partial<CfFtpInfo> = {
    ...getFieldValuesFromSection(template.main as FormTemplateSection),
  };

  return omitBy(cfFtpInfo, isNil) as unknown as CfFtpInfo;
}

function getFieldValuesFromSection(
  templateSection: FormTemplateSection,
): Partial<CfFtpInfo> {
  return Object.entries(templateSection?.fields)
    .filter(([_fieldName, field]) => field.initial != null)
    .reduce((previousValue, [fieldName, field]) => ({
      ...previousValue,
      [fieldName]: field.initial,
    }), {});
}
